import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { AgenciesContent } from '@/pageContents/agencies/AgenciesContent';

const AgenciesPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Agenturen | Starjack Backoffice</title>
            </Helmet>

            <AgenciesContent />
        </>
    );
};

AgenciesPage.isProtected = true;
AgenciesPage.permissions = [Permission.ADMIN];
AgenciesPage.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);

export default AgenciesPage;
